import React from 'react'
import { Icon, Button, Divider, Container, Segment, Header, Table, Image, Label } from 'semantic-ui-react';


const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

const ResultsBreakdownTableSimple = ({ title, icon, rows, footer }) => {

    const { test } = footer;

    return (
        <Segment basic>
            <Divider horizontal>
                <Header as='h4'>
                    {icon && <Icon name={icon} />}
                    {title}
                </Header>
            </Divider>

            <br />

            <Table definition celled>

                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell width={4}></Table.HeaderCell>
                        <Table.HeaderCell>Questions Total</Table.HeaderCell>
                        <Table.HeaderCell>Questions Correct</Table.HeaderCell>
                        <Table.HeaderCell>Questions %</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>

                    {rows.map(([key, value], index) => {
                        return (
                            <Table.Row key={index}>
                                <Table.Cell width={4}>{capitalize(key)}</Table.Cell>
                                <Table.Cell>{value['questions_available']}</Table.Cell>
                                <Table.Cell>{value['questions_correct']}</Table.Cell>
                                <Table.Cell>{`${(Number(value['questions_correct']) / Number(value['questions_answered']) * 100).toFixed(0)}%`}</Table.Cell>
                            </Table.Row>
                        )

                    })}


                </Table.Body>

                {footer &&

                    <Table.Footer>

                        {footer.map(([key, value], index) => {
                            return (
                                <Table.Row key={index}>

                                    <Table.HeaderCell width={4}></Table.HeaderCell>
                                    <Table.HeaderCell>{value['questions_available']}</Table.HeaderCell>
                                    <Table.HeaderCell>{value['questions_correct']}</Table.HeaderCell>
                                    <Table.HeaderCell>{`${(Number(value['questions_correct']) / Number(value['questions_answered']) * 100).toFixed(0)}%`}</Table.HeaderCell>

                                </Table.Row>
                            )

                        })}

                    </Table.Footer>}

            </Table>

        </Segment>
    )
}

export default ResultsBreakdownTableSimple
